import { logger } from '../logger'

export const getTimestamp = (item: any) => {
  if (typeof item.timestamp === 'number') {
    return BigInt(item.timestamp)
  }
  if (item.timestamp instanceof Date) {
    return BigInt(item.timestamp.getTime()) * BigInt(1_000_000)
  }

  logger.debug('Could not get timestamp for item', { item })

  return BigInt(0)
}
